import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'

interface DeleteMovementModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  movementDescription?: string
}

export const DeleteMovementModal = ({ isOpen, onClose, onConfirm, movementDescription }: DeleteMovementModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <AlertTriangle className="h-5 w-5" />
            Eliminar Movimiento
          </DialogTitle>
          <DialogDescription>
            ¿Está seguro de que desea eliminar este movimiento?
            {movementDescription && <span> "{movementDescription}"</span>}
            {" "}Esta acción no se puede deshacer y afectará el saldo de la cuenta.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-4">
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button variant="destructive" onClick={onConfirm}>Eliminar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

